import React from 'react'
import {
    H3,
    Intent,
    Alert,
} from "@blueprintjs/core";

const Access = ({ isOpen,
    onClose,
    onConfirm,
    cancelButtonText,
    confirmButtonText,
    intent,
    title,
    text,
    icon
}) => {
    return (
        <Alert
            isOpen={isOpen}
            onClose={onClose}
            cancelButtonText={cancelButtonText ? cancelButtonText : "Cancel"}
            confirmButtonText={confirmButtonText ? confirmButtonText : "Confirm"}
            icon={icon ? icon : ""}
            onConfirm={onConfirm}
            intent={intent ? intent : Intent.Primary}
        >
            <H3>{title}</H3>
            {text}
            <br />
        </Alert>
    )
}

export default Access
